import {IKuPiper} from '@/middleware/types';
import {initSlots} from './slot';
import {initProxy} from './proxy';

export default class TocPlugin {
    options: {
        name: string;
    };

    constructor(options?: any) {
        this.options = {
            name: 'TocPlugin',
            ...options,
        };
    }

    apply(kuPiper: IKuPiper) {
        initSlots(kuPiper, this.options);
        initProxy(kuPiper, this.options);
    }
}
